module.exports = __webpack_public_path__ + "media/images/matrix_preview_portrait-347f075d50b4ed29dff97ede5ca6528c.png";